// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-17d304e1] {\n  margin-bottom: 1rem;\n}\n.v-select[data-v-17d304e1] {\n  min-width: 30rem;\n}", ""]);
// Exports
module.exports = exports;
